import { ErpSource } from "../models/constants";

export const isSAPSource = (source: string): boolean => {
  return source === ErpSource.SAP;
};
